import { Grid } from '../../../../Common/Grid';
import { Button, Input, Typography } from "@fullscreendigital/carrefour-dex-fe";
import { TitleHeader } from '../../../Common/TitleHeader';
import { useNotification } from "../../../../../../hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { getValidationSchema, initialValues } from "./helpers";
import { useFormik } from "formik";
import { useQuery } from "react-query";
import { makeCoreGetRequest, makeCorePostRequest } from "../../../../../../utils/api";
import { formatErrorMessage } from "../../../../../../utils/formatting";
import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Paper, CircularProgress } from "@mui/material";
import { URLS } from "../../../constants";

const Step3 = () => {
  const { showNotification } = useNotification();
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state || '';

  const validationSchema = useMemo(() => getValidationSchema(), []);
  const formik = useFormik({
    enableReinitialize: false,
    validateOnChange: false,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values: any) => {
      const supportList = values.supportList?.map(support => ({
        supportTypeId: support.supportTypeId,
        supportNumber: support.supportNumber
      }));

      try {
        await makeCorePostRequest('/shop-reception-mobile/truck/shop/exit/save-supports/' + id, supportList);
        navigate(URLS.AUTH_RETURN_STEP_4, { state: id });
      } catch (error) {
        showNotification({
          message: `Error while submitting. ${formatErrorMessage(error)}`,
          type: 'error'
        });
      }
    }
  });

  const { data: returnTruck, isLoading: isLoadingSupportList } = useQuery(
    'supportListReturn',
    async () => {
      const truck = await makeCoreGetRequest('/shop-reception-mobile/truck/shop/exit/return-supports/' + id, null);

      await formik.setValues({ supportList: truck.supportList });
      return truck;
    },
    {
      onError: error => {
        showNotification({
          message: `Error while fetching supports. ${formatErrorMessage(error)}`,
          type: 'error'
        });
      }
    }
  );

  const handleInputChange = (supportTypeId: string, value: string) => {
    const updatedSupportList = formik.values.supportList?.map((support: any) => {
      if (support.supportTypeId === supportTypeId) {
        return { ...support, supportNumber: value };
      }
      return support;
    });

    formik.setFieldValue('supportList', updatedSupportList);
  };

  if (isLoadingSupportList) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />;
  }

  const rows = formik.values.supportList?.map((support: any) => ({
    packagingType: support.supportTypeNameAndCode,
    amount: support.supportNumber,
    supportTypeId: support.supportTypeId
  }));

  const hasEmptySupportNumber = (supportList: any) => {
    return supportList?.some((support: any) => !support.supportNumber);
  };

  return (
    <Grid
      gridContainerStyle={{ marginTop: '20px' }}
      maxWidth='xs'
      items={[
        <TitleHeader title='ÎNREGISTREAZǍ CAMION' />,
        <>
          <Typography variant='medium' component='p'>Numǎr camion: {returnTruck?.truckNumber}</Typography>
          <Typography variant='medium' component='p'>Destinație: {returnTruck?.depositOrHubName}</Typography>
        </>,
        <TableContainer component={Paper}>
          <Table>
            <TableHead style={{ background: '#0970e6' }}>
              <TableRow>
                <TableCell align="left" style={{fontFamily: 'Ubuntu', color: '#f8f9fb', fontWeight: 'bold'}}>TIP AMBALAJ</TableCell>
                <TableCell align="center" style={{fontFamily: 'Ubuntu', color: '#f8f9fb', fontWeight: 'bold'}}>CANTITATE</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) => (
                <TableRow key={row.supportTypeId}>
                  <TableCell align="left">{row.packagingType}</TableCell>
                  <TableCell align="center">
                    <Input
                      type="number"
                      value={row.amount}
                      onChange={(e) => handleInputChange(row.supportTypeId, (e.target as HTMLInputElement).value)}
                      variant='standard'
                      id='support-input'
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>,
        <Button
          type='button'
          variant='contained'
          label='CONFIRMǍ AMBALAJE'
          onClick={() => formik.handleSubmit()}
          style={{ width: '100%' }}
          disabled={hasEmptySupportNumber(formik.values.supportList) || formik.isSubmitting}
        />
      ]}
      itemsPerRow={1}
    />
  );
}

export default Step3;
